// CVF-161: true top-left anchor of a combine selection. Independent min over
// left/top - NOT "the object with min left/top" - because on L/T/cross shapes
// the leftmost booth and the topmost booth can be two different booths.
// No fabric import here on purpose, so this stays unit-testable on its own.
export const getSelectionAnchor = (objects)=>{
    var lefts = objects.map(function(o){ return o.left });
    var tops = objects.map(function(o){ return o.top });
    return { left: Math.min(...lefts), top: Math.min(...tops) }
}

// Bounding-box min of a polygon's own points. The combine point-transform subtracts
// this twice (once directly, once via pathOffset), so it must be the true min, not
// the min-(x+y) vertex - on concave custom booths those differ and the booth shifts
// by 2x the gap.
export const getPointsMin = (points)=>{
    return { x: Math.min(...points.map(p => p.x)), y: Math.min(...points.map(p => p.y)) }
}

// CVF-161: converts a selection-relative anchor point (e.g. from getSelectionAnchor
// above) into a true canvas-absolute point.
//
// While several booths are grouped into a Fabric ActiveSelection, each booth's own
// .left/.top stop being real canvas coordinates - Fabric rewrites them relative to
// the selection. The combine engine builds its polygon in that relative space (the
// shape itself comes out correct), but placing the finished shape on the canvas
// needs a true absolute position. That's measured directly off one real object via
// fabric.util.qrDecompose(object.calcTransformMatrix()), rather than derived by hand.
//
// A second correction: the reference object's own .left/.top is center-based, not
// corner-based, so the measured offset is short by half that object's own
// width/height. Confirmed with a non-square (20x10) reference object, where the X
// and Y corrections came out as two different values matching that object's own
// half-width/half-height - ruling out a fixed grid-size constant.
//
// ponytail: only verified against unrotated selections (angle=0). Re-verify this
// formula if a rotated combine ever surfaces a position bug.
export const getTrueAbsoluteAnchor = (referenceObject, relativeAnchor, qrDecompose)=>{
    var refAbsolute = qrDecompose(referenceObject.calcTransformMatrix());
    var offsetX = refAbsolute.translateX - referenceObject.left;
    var offsetY = refAbsolute.translateY - referenceObject.top;
    var refScaleX = referenceObject.scaleX || 1;
    var refScaleY = referenceObject.scaleY || 1;
    var halfRefWidth = (referenceObject.width * refScaleX) / 2;
    var halfRefHeight = (referenceObject.height * refScaleY) / 2;
    return {
        left: offsetX + relativeAnchor.left - halfRefWidth,
        top: offsetY + relativeAnchor.top - halfRefHeight,
    }
}
